import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, TitleBar } from '@shopify/app-bridge-react';

const ModifyCountDialog = ({ shopify, modifyItemId, printCounts, modifyItem, setPrintCount }) => {
  const [replace, setReplace] = useState(null);

  const updateQuantity = () => {
    setPrintCount(modifyItemId, modifyItem, replace);
    setReplace(0);
    shopify.modal.hide('print-count-modal');
  }

  const validateQuantity = (event) => {
    let value = event.target.value
    setReplace(value.replace(/\D/g,''));
  }

  return(
    <Modal id="print-count-modal" variant="large">
      <div className="modal-body">
        <p>
          <strong>{modifyItem?.name}</strong>
        </p>
        <ul>
          { modifyItem?.options && modifyItem?.options.map(option =>
              <li key={option.name}>
                <strong>{ option.name }</strong>: { option.value }
              </li>
            )
          }
        </ul>
        <p>
          <strong>Inventory</strong>: {modifyItem?.quantity}
        </p>

        <hr/>

        <p style={{ 'color': '#8e1f0b' }}>
          Updated Print Quantity
        </p>
        
        <input type="number" onFocus={e => e.target.select()} value={replace || printCounts[modifyItemId]?.count || 0} onChange={validateQuantity} />
      </div>
      <TitleBar title="Update Quantity">
        <button onClick={() => updateQuantity()} variant="primary">Update Quantity</button>
        <button onClick={() => shopify.modal.hide('print-count-modal')}>Cancel</button>
      </TitleBar>
    </Modal>
  )
}

export default ModifyCountDialog;